import React from 'react';

type Props = {
  size?: 'sm' | 'md' | 'lg';
};

const SIZES = {
  sm: { sq: 28, dot: 9, text: '1.5rem' },
  md: { sq: 40, dot: 12, text: '2rem' },
  lg: { sq: 56, dot: 16, text: '2.75rem' },
};

const TablyMark: React.FC<Props> = ({ size = 'md' }) => {
  const s = SIZES[size];
  return (
    <span className="tably-mark" aria-label="Tably">
      <span
        className="tably-mark__square"
        style={{ width: s.sq, height: s.sq, borderRadius: s.sq * 0.22 }}
      >
        <span
          className="tably-mark__dot"
          style={{
            width: s.dot,
            height: s.dot,
            bottom: s.sq * 0.17,
            right: s.sq * 0.17,
          }}
        />
      </span>
      <span className="tably-mark__text" style={{ fontSize: s.text }}>
        tably
      </span>
    </span>
  );
};

export default TablyMark;
